import { gql } from '@apollo/client';
import { OrganizationFragment } from '../organization/Organization';
import { AccountFragment } from '../account/Account';
import { LanguageFragment } from '../language/Language';
import { AvatarFragment } from './Avatar';

export const PersonDetailedFragment = gql`
  fragment PersonDetailed on PersonDetailed {
    status
    avatar {
      ...Avatar
    }
    lastName
    firstName
    immutableId
    immutableGuid
    email
    phoneNumber
    mobileNumber
    language {
      ...Language
    }
    professionCode
    titleCode
    sicId
    activationDate
    creationDate
    account {
      ...Account
    }
    organization {
      ...Organization
    }
  }
  ${AvatarFragment}
  ${LanguageFragment}
  ${AccountFragment}
  ${OrganizationFragment}
`;
